export class TvLayout {

    private active: boolean;
    private backgroundColour: string;
    private internalId: string;
    private name: string;
    private tvFormatCode: string;
    private textPrimaryColour: string;
    private textSecondaryColour: string;

    constructor(active?: boolean, backgroundColour?: string, internalId?: string, name?: string, textPrimaryColour?: string, textSecondaryColour?: string, tvFormatCode?: string) {
        this.active = active;
        this.backgroundColour = backgroundColour;
        this.internalId = internalId;
        this.name = name;
        this.textPrimaryColour = textPrimaryColour;
        this.textSecondaryColour = textSecondaryColour;
        this.tvFormatCode = tvFormatCode;
    }

    public get Active() {
        return this.active;
    }
    public get BackgroundColour() {
        return this.backgroundColour;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Name() {
        return this.name;
    }
    public get TextPrimaryColour() {
        return this.textPrimaryColour;
    }
    public get TextSecondaryColour() {
        return this.textSecondaryColour;
    }
    public get TvFormatCode() {
        return this.tvFormatCode;
    }
    public set Active(active) {
        this.active = active;
    }
    public set BackgroundColour(backgroundColour) {
        this.backgroundColour = backgroundColour;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Name(name) {
        this.name = name;
    }
    public set TextPrimaryColour(textPrimaryColour) {
        this.textPrimaryColour = textPrimaryColour;
    }
    public set TextSecondaryColour(textSecondaryColour) {
        this.textSecondaryColour = textSecondaryColour;
    }
    public set TvFormatCode(tvFormatCode) {
        this.tvFormatCode = tvFormatCode;
    }
}
